module.exports = __webpack_public_path__ + "static/media/Helbredspartner-logo.02b303b1.webp";